import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import merge from 'lodash/merge';
import commify from '../../../modules/ajio-util/commify.js';
import queryUtil from '../../../modules/ajio-util/query.js';
import { parseProductQueryString, stringifyFacets } from '../../../utils/products.js';
import { generateEvent } from '../../../utils/dataGrinch';

import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../refresh/constants/luxeScreenType';

import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getFeatureVariant } from '../../../refresh/organism/ABFeature/Feature';
import {
  getEnableRating,
  getEnableRatingLabelPLP,
  getCountDisplayConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import {
  getTotalCountLabel,
  getPlpTotalCountDisplay
} from '../../../modules/ajio-util/countDisplay';

/**
 * Components for just above product grid
 */

class TopFiltersDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAscending: !window.location.href.includes('prce-desc'),
      priceSelected: !!window.location.href.includes('prce')
    };
  }

  // componentDidUpdate() {
  //   if (window.location.href.includes('prce-asc') && this.state.showAscending == false) {
  //     this.setState({ showAscending: true });
  //   }
  //   if (window.location.href.includes('prce-desc') && this.state.showAscending == true) {
  //     this.setState({ showAscending: false });
  //   }
  // }

  getFacetsQuery() {
    const { facetsQuery } = this.props;
    if (Object.keys(facetsQuery).length) {
      return stringifyFacets(merge({}, facetsQuery));
    } else {
      return null;
    }
  }

  // displayOption(code) {
  //   if (code.includes('prce')) {
  //     if (code.includes('asc') && this.state.showAscending) {
  //       return true;
  //     } else if (code.includes('desc') && !this.state.showAscending) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return true;
  //   }
  // }

  render() {
    const {
      newDesignLuxe,
      totalResults,
      sorts = [],
      productToggle,
      pushToHistory,
      facetsQuery,
      metaData: { sis = false, name = '' } = {},
      enableRating,
      enableRatingLabelPLP,
      totalCountDisplay = {}
    } = this.props;
    const totalCountText = getTotalCountLabel(totalResults, totalCountDisplay, {
      suffix: 'Items Found',
      legacyText: `${commify(totalResults)} Items Found`
    });
    const { plp: { screenType = '', screenName = '' } = {} } = luxeScreen;
    const queryString = queryUtil.parseSearch(location.search) || {};
    const query = {
      ...queryString,
      ...parseProductQueryString(queryString.query || '')
    };
    let { viewType = 'outfitview', gridColumns = 3 } = query;
    let productToggleOff = true;

    // if (productToggle == "TOGGLE_ON_PRODUCT") {
    //   viewType = "productview";
    // } else if (productToggle == "TOGGLE_OFF_MODEL") {
    //   productToggleOff = false;
    // }

    return (
      <div className={`${newDesignLuxe ? 'luxe-newdesign' : ''} filter-container`}>
        <div className="filter">
          <div className="length"  aria-live='polite' aria-atomic='true'>
            <strong>{totalCountText}</strong>
          </div>

          <div className="grid">
            <label id='grid-group-id' className="grid-text" aria-label="Grid">Grid </label>
            <div className="grid-container" role='group' aria-labelledby='grid-group-id'>
              <div className={`three-grid-container ${gridColumns == 3 ? 'active' : ''}`}>
                <div
                  className="three-grid"
                  onClick={() => {
                    const facetsQuery = this.getFacetsQuery();
                    let queryObj = {
                      gridColumns: 3,
                      facets: facetsQuery,
                      changeGrid: true
                    };
                    pushToHistory(queryObj);
                  }}
                  aria-label="Show 3 products per row"
                  role="button"
                  tabIndex={0}
                />
              </div>
              <div className={`five-grid-container ${gridColumns == 5 ? 'active' : ''}`}>
                <div
                  className="five-grid"
                  onClick={() => {
                    const facetsQuery = this.getFacetsQuery();
                    let queryObj = {
                      gridColumns: 5,
                      facets: facetsQuery,
                      changeGrid: true
                    };
                    pushToHistory(queryObj);
                  }}
                  aria-label="Show 5 products per row"
                  role="button"
                  tabIndex={0}
                />
              </div>
            </div>
          </div>
          {/* {productToggleOff ? (
            <div className="view">
              <label>View :</label>
              <div className="productview-action">
                <div
                  className={`model-view ${
                    viewType == "outfitview" ? "active" : ""
                  }`}
                  onClick={() => {
                    const facetsQuery = this.getFacetsQuery();
                    let queryObj = {
                      viewType : "outfitview",
                      facets : facetsQuery
                    }
                    pushToHistory(queryObj);
                  }}
                >
                  {" Model  "}
                </div>
                <div
                  className={`product-view ${
                    viewType == "productview" ? "active" : ""
                  }`}
                  onClick={() => {
                    const facetsQuery = this.getFacetsQuery();
                    let queryObj = {
                      viewType : "productview",
                      facets : facetsQuery
                    }
                    pushToHistory(queryObj);
                  }}
                >
                  {"  Product"}
                </div>
              </div>
            </div>
          ) : (
            ""
          )} */}

          <div className={`sort ${productToggleOff == false ? 'product-Toggle-Off' : ''}`}>
            <label className="sortby-filter" aria-label="Sort By" htmlFor="sortBy">
              Sort By
            </label>
              <div style={{
                height:0,
                width:0,
                pointerEvents:"none",
                opacity:0
              }} aria-live='polite' aria-atomic='true'>Sorted By -         
{sorts.find(item => Boolean(item.selected))?.name}
              </div>
              <div className="filter-dropdown">
                <select
                  className={newDesignLuxe ? 'filter-dropdown-input' : ''}
                  onChange={event => {
                    const facetsQuery = this.getFacetsQuery();
                    if (newDesignLuxe) {
                      gtmEventPush({
                        event: 'plp_sort_apply',
                        event_category: 'product list interactions',
                        event_action: 'sort applied',
                        event_label: event.target.value,
                        store_type: 'luxe',
                        screen_name: screenName,
                        screen_type: screenType
                      });
                      segmentEventPush({
                        event: 'Plp Sort Applied',
                        event_category: 'product list interactions',
                        event_action: 'sort applied',
                        sort_type: event.target.value || "",
                        store_type: 'luxe',
                        screen_name: screenName,
                        screen_source: screenType
                      })
                    } else {
                      generateEvent({
                        Event: 'Sort',
                        value: {
                          SortValue: event.target.value
                        }
                      });

                       segmentEventPush({
                        event: 'Plp Sort Applied',
                        event_category: 'product list interactions',
                        event_action: 'sort applied',
                        sort_type: event.target.value || "",
                        store_type: 'luxe',
                        screen_name: screenName,
                        screen_source: screenType
                      })
                      
                    }

                  gtmEventPush({
                    event: 'buttonTap',
                    event_category: 'buttonTap',
                    event_action: 'plp_sort_clicked',
                    event_label: (sorts ?? []).find(el => el.code === event.target.value)?.name
                  });

                 

                    let queryObj = {
                      sortBy: event.target.value,
                      currentPage: 0,
                      facets: facetsQuery
                    };
                    pushToHistory(queryObj);
                  }}
                  id="sortBy"
                >
                  {sorts.map((item, key) => {
                    const { code, name, selected } = item;
                    if (
                      name.toLowerCase() === 'ratings' &&
                      (!enableRating ||
                        !enableRatingLabelPLP ||
                        getFeatureVariant('rating-label-display-msite-plp') === '0' ||
                        newDesignLuxe)
                    ) {
                      return null;
                    }
                    return (
                      <option value={code} selected={selected} key={`sort-by-${key}`}>
                        {name}
                      </option>
                    );
                  })}
                </select>
                <span className="ic-Chevron-down" />
              </div>
            
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { sorts = {}, productsAdditionalInfo = {}, request = {}, metaData = {}, flags } = state;
  const { results = [] } = sorts;
  const { productToggle = '' } = productsAdditionalInfo;
  const { totalResults = 0 } = request;
  const { facets = {} } = state;
  const { currentFacets = {} } = facets;
  const { query: facetsQuery = {} } = currentFacets;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  const countConfig = getCountDisplayConfig(state);
  const totalCountDisplay = getPlpTotalCountDisplay(countConfig, storeName);

  return {
    newDesignLuxe,
    sorts: results,
    totalResults,
    totalCountDisplay,
    productToggle,
    facetsQuery,
    metaData,
    enableRating: getEnableRating(flags,state),
    enableRatingLabelPLP: getEnableRatingLabelPLP(state) === 'ON'
  };
};

export default withRouter(connect(mapStateToProps)(TopFiltersDesktop));
